export default __webpack_public_path__ + "static/media/3.5480651b.svg";